import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
import layout from "@/views/layout";
import towLayout from "@/views/layout/tow";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "", // 用户token
    roleState: "", // 角色状态
    roleInfo: [], // 角色信息
    userInfo: [], // 用户信息
    editInfo: [], // 编辑信息
    contractData: {}, // 合同数据
  },
  mutations: {
    //动作事件
    loginIn(state, json) {
      //登录
      localStorage.setItem("token", json.token);
      localStorage.setItem("role", JSON.stringify(json.grants));  // 存储权限数据
      state.token = json.token;
    },
    loginOut(state) {
      //退出
      localStorage.clear();
      state.token = "";
      state.roleState = "";
      router.push("/login");
    },
    loadRole(state) {
      if (localStorage["role"] == undefined || localStorage["role"] == "") {
        this.commit("loginOut");
      } else {
        state.roleState = JSON.parse(localStorage["role"]);   // 从localStorage获取
        //取动态路由及导航栏
        this.commit("treerouters", state.roleState);
      }
    },
    setContractData(state, value) {
      state.contractData = value;
    },
    setEditInfo(state, data) {
      state.editInfo = [];
      state.editInfo = data;
    },
    treerouters(state, data) {
      let resData = data;
      let tree = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i]["pid"] === 0) {
          let temp = {
            id: resData[i].id,
            tid: resData[i].tid,
            path: "/" + resData[i].directory,
            title: resData[i].title,
            component: resData[i].layout == "layout" ? layout : towLayout,
            meta: { title: resData[i].title },
            redirect: resData[i].redirect,
            children: [],
          };
          tree.push(temp);
          resData.splice(i, 1);
          i--;
        }
      }
      run(tree);

      function run(chiArr) {
        if (resData.length !== 0) {
          for (let i = 0; i < chiArr.length; i++) {
            for (let j = 0; j < resData.length; j++) {
              if (chiArr[i].id == resData[j]["tid"]) {
                let x = resData[j];
                if (x.layout) {
                  let erji = {
                    id: x.id,
                    tid: x.tid,
                    path: x.directory,
                    component: x.layout == "layout" ? layout : towLayout,
                    redirect: x.component,
                    url: x.component,
                    meta: { title: x.title },
                    children: []
                  };
                  if (x.path) {
                    erji.children = [
                      {
                        path: x.path,
                        component: () => import(`@/views${x.component}.vue`),
                        meta: { title: x.title },
                        children: [],
                      },
                    ];
                  }
                  chiArr[i]["children"].push(erji);
                } else {
                  let parent = chiArr[i].path;
                  let erji = {
                    id: x.id,
                    tid: x.tid,
                    path: x.path,
                    component: () => import(`@/views${x.component}.vue`),
                    meta: { title: x.title },
                    children: [],
                  };
                  chiArr[i]["children"].push(erji);
                }

                resData.splice(j, 1);
                j--;
              }
            }
            run(chiArr[i].children);
          }
        }
      }
      for (let i = router.options.routes.length - 1; i >= 0; i--) {
        tree.unshift(router.options.routes[i]);
      }
      tree.push({ path: "*", redirect: "/login" });
      console.log("tree", tree);
      router.addRoutes(tree);
    },
  },
  actions: {
    //异步
  },
  getters: {
    isLogin: (state) => !!state.token, //监听token变化
    role: (state) => !!state.roleState,
    editInfo: (state) => state.editInfo,
  },
});

export default store;
